import { EventType, PublicClientApplication } from '@azure/msal-browser';

const b2cPolicies = {
  names: {
    signUpSignIn: import.meta.env.VITE_AUTH_USERFLOW_NAME,
  },
  authorities: {
    signUpSignIn: {
      authority: `https://${import.meta.env.VITE_AUTH_TENANT_NAME}.b2clogin.com/${import.meta.env.VITE_AUTH_TENANT_NAME}.onmicrosoft.com/${import.meta.env.VITE_AUTH_USERFLOW_NAME}`,
    },
    forgotPassword: {
      authority: `https://${import.meta.env.VITE_AUTH_TENANT_NAME}.b2clogin.com/${import.meta.env.VITE_AUTH_TENANT_NAME}.onmicrosoft.com/${import.meta.env.VITE_AUTH_FORGOT_FLOW}`,
    },
  },
  authorityDomain: `${import.meta.env.VITE_AUTH_TENANT_NAME}.b2clogin.com`,
};

const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_PUBLIC_CLIENT_ID, // Client Id of the app registration
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose sign-up/sign-in user-flow as your default.
    knownAuthorities: [b2cPolicies.authorityDomain], // You must identify your tenant's domain as a known authority.
    redirectUrl: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // If you wish to store cache items in cookies as well as browser cache, set this to "true".
  },
};

export const loginRequest = {
  scopes: ['openid'],
};

export const tokenRequestBase = {
  scopes: [`https://${import.meta.env.VITE_AUTH_TENANT_NAME}.onmicrosoft.com/${import.meta.env.VITE_AUTH_SERVER_SCOPE}/api`],
};

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback(message => {
  if (message.eventType === EventType.LOGIN_SUCCESS) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts[0]);
  }
});

export { msalInstance };
